import { TradingOrder, TradingOrderType } from "../config/trading";
import { EditingPosition } from "./editingPosition";
import { EditingOrder } from "./editingOrder";


export class EditingEntryOrder extends EditingOrder {
    setType(t: TradingOrderType) { this.trd.type = t; }
    constructor(pos: EditingPosition, trd: TradingOrder) {
        switch (trd.type) {
            case TradingOrderType.Entry:
            case TradingOrderType.Limit:
                break;
            default:
                throw 'not entry order';
        }
        super(pos, trd);
    }
}
